import React, { createContext, useContext, useState, useEffect } from 'react';

// Context for balance visibility
const BalanceVisibilityContext = createContext();

export const BalanceVisibilityProvider = ({ children }) => {
  const [balanceVisible, setBalanceVisible] = useState(() => {
    // Load from localStorage, default to visible
    const saved = localStorage.getItem('balanceVisible');
    return saved !== null ? JSON.parse(saved) : true;
  });

  const toggleBalanceVisibility = () => {
    setBalanceVisible(prev => {
      const newValue = !prev;
      localStorage.setItem('balanceVisible', JSON.stringify(newValue));
      return newValue;
    });
  };

  const formatBalance = (amount) => {
    if (!balanceVisible) {
      return '****';
    }
    return amount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00';
  };

  return (
    <BalanceVisibilityContext.Provider value={{ balanceVisible, toggleBalanceVisibility, formatBalance }}>
      {children}
    </BalanceVisibilityContext.Provider>
  );
};

export const useBalanceVisibility = () => {
  const context = useContext(BalanceVisibilityContext);
  if (!context) {
    throw new Error('useBalanceVisibility must be used within BalanceVisibilityProvider');
  }
  return context;
};
